import { render, staticRenderFns } from "./LogisticInfoBox.vue?vue&type=template&id=0053fba8&scoped=true"
import script from "./LogisticInfoBox.vue?vue&type=script&lang=js"
export * from "./LogisticInfoBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0053fba8",
  null
  
)

export default component.exports